import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const links = [
  { label: "Manifest", href: "#manifest" },
  { label: "Program", href: "#program" },
  { label: "Tarife", href: "#tarife" },
  { label: "Antrenor", href: "#antrenor" },
  { label: "Video", href: "#video" },
  { label: "Galerie", href: "#galerie" },
  { label: "Contact", href: "#contact" },
];

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [time, setTime] = useState("");

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    const tick = () => {
      const d = new Date();
      const hh = String(d.getHours()).padStart(2, "0");
      const mm = String(d.getMinutes()).padStart(2, "0");
      setTime(`${hh}:${mm} HD`);
    };
    tick();
    const t = setInterval(tick, 30000);
    return () => {
      window.removeEventListener("scroll", onScroll);
      clearInterval(t);
    };
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "backdrop-blur-xl bg-[#050505]/70 border-b border-[rgba(242,235,229,0.08)]" : ""
      }`}
    >
      <div className="container-brutal flex items-center justify-between px-6 md:px-12 py-5">
        <a href="#top" data-testid="nav-logo" className="flex items-center gap-3 group">
          <div className="w-10 h-10 md:w-11 md:h-11 rounded-full overflow-hidden bg-white ring-1 ring-[#D91604]/40 group-hover:ring-[#D91604] transition-all shrink-0">
            <img
              src="https://customer-assets.emergentagent.com/job_elite-karate-3d/artifacts/17qa70pq_sigla%20club%202015-1.webp"
              alt="Elite Center Hunedoara"
              className="w-full h-full object-cover scale-[1.06]"
            />
          </div>
          <span className="font-anton text-lg md:text-xl tracking-widest">
            ELITE CENTER <span className="text-[#8a8a8a]">/</span> HUNEDOARA
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="link-underline text-[13px] tracking-widest uppercase text-[#f2ebe5]/85 hover:text-[#f2ebe5]"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-4">
          <span className="text-[11px] tracking-[0.28em] uppercase text-[#8a8a8a]" data-testid="nav-time">
            {time}
          </span>
          <a
            href="tel:0738711661"
            data-testid="nav-cta-call"
            className="font-anton text-sm tracking-widest px-4 py-2 border border-[rgba(242,235,229,0.22)] hover:bg-[#D91604] hover:text-[#050505] hover:border-[#D91604] transition-colors"
          >
            SUNĂ ACUM
          </a>
        </div>

        <button
          className="md:hidden font-anton text-sm tracking-widest text-[#f2ebe5]"
          onClick={() => setOpen(!open)}
          data-testid="nav-mobile-toggle"
          aria-label="menu"
        >
          {open ? "ÎNCHIDE" : "MENIU"}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.35, ease: [0.65, 0.05, 0.36, 1] }}
            className="md:hidden border-t border-[rgba(242,235,229,0.08)] bg-[#050505]/95 backdrop-blur-xl overflow-hidden"
          >
            <div className="flex flex-col p-6 gap-4">
              {links.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  onClick={() => setOpen(false)}
                  className="font-anton text-2xl tracking-wider"
                  data-testid={`nav-mobile-${l.label.toLowerCase()}`}
                >
                  {l.label.toUpperCase()}
                </a>
              ))}
              <a
                href="tel:0738711661"
                className="mt-2 inline-block font-anton text-sm tracking-widest px-4 py-2 border border-[#D91604] text-[#D91604]"
                data-testid="nav-mobile-cta"
              >
                SUNĂ · 0738 711 661
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
};

export default Navbar;
